import { formatRail } from "@/shared/utils/railDisplay";

export const CRYPTO_CURRENCIES: ReadonlySet<string> = new Set(["USDT", "USDC", "BTC", "ETH"]);

export const isCryptoCurrency = (currency: string): boolean => CRYPTO_CURRENCIES.has(currency.toUpperCase());

/**
 * Payin/payout methods a currency supports on the NEW payments runtime — the "load & send" chips on the
 * wallet card. MIRRORS the provider capability matrix declared in coloca-nest (the only source of truth; `GET
 * /internal/payments/wallets/currencies` returns just the currency codes, not the rails, so this cannot be
 * fetched):
 *
 * - Bitso-payment.provider.ts → PIX/BRA/BRL, SPEI/MEX/MXN, CBU_CVU/ARG/ARS (payin + payout)
 * - Kamin-payment.provider.ts → BREB/COL/COP (payin + payout)
 * - Bepay-payment.provider.ts → NEQUI/COL/COP + BANCOLOMBIA_BUTTON/COL/COP (payin only) Labels come from
 *   `formatRail` so they never drift from the payments-activity / payout-rescue views.
 *
 * A currency without an entry has NO runtime corridor yet: an org can still activate a wallet for it
 * (WalletCurrency lists 12 — COP, MXN, BRL, USD, PEN, ARS, PYG, USDT, CLP, GTQ, EUR, CRC), but no provider
 * services a payin/payout on it, so the card hides the methods section rather than invent one. Keep this map
 * in sync with the two adapters above whenever a corridor goes live.
 */
export const WALLET_METHODS_BY_CURRENCY: Record<string, readonly string[]> = {
  COP: [formatRail("BREB"), formatRail("NEQUI"), formatRail("BANCOLOMBIA_BUTTON")],
  BRL: [formatRail("PIX")],
  MXN: [formatRail("SPEI")],
  ARS: [formatRail("CBU_CVU")],
};

export const getMethodsForCurrency = (currency: string): readonly string[] =>
  WALLET_METHODS_BY_CURRENCY[currency.toUpperCase()] ?? [];
